export default "__VITE_ASSET__6354bf15__"